import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1);
const _hoisted_5 = {
  key: 0,
  class: "row"
};
const _hoisted_6 = {
  class: "col-12 mb-3"
};
const _hoisted_7 = {
  key: 1,
  class: "row"
};
const _hoisted_8 = {
  class: "col-12 mb-3"
};
const _hoisted_9 = {
  key: 2,
  class: "mt-2 OffBoardingStep1"
};
const _hoisted_10 = {
  class: "row"
};
const _hoisted_11 = {
  class: "col-12"
};
const _hoisted_12 = {
  class: "row mb-2"
};
const _hoisted_13 = {
  class: "i-layer"
};
const _hoisted_14 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_19 = {
  class: "mt-4 mb-3"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "Original Owner")], -1);
const _hoisted_21 = {
  class: "pl-4 pr-4 mb-4"
};
const _hoisted_22 = {
  class: "row mt-3"
};
const _hoisted_23 = {
  class: "col-lg-3 col-12 text-left fw-medium fsi-14"
};
const _hoisted_24 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14"
};
const _hoisted_25 = {
  class: "row mt-3"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-medium fsi-14"
}, "ID", -1);
const _hoisted_27 = {
  key: 1,
  class: "row mt-3"
};
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-medium fsi-14"
}, "Address", -1);
const _hoisted_29 = {
  class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14"
};
const _hoisted_30 = {
  key: 1,
  class: "row mb-3 mt-3"
};
const _hoisted_31 = {
  class: "col-12 mb-1"
};
const _hoisted_32 = {
  class: "row"
};
const _hoisted_33 = {
  class: "col-12 text-left fw-bold fsi-20 cursor-pointer"
};
const _hoisted_34 = {
  key: 0
};
const _hoisted_35 = {
  class: "i-layer mb-2"
};
const _hoisted_36 = {
  key: 0,
  class: "mt-3 mb-2"
};
const _hoisted_37 = {
  class: "row mb-3 mt-3"
};
const _hoisted_38 = {
  class: "col-12 mb-1"
};
const _hoisted_39 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_40 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tip = _resolveComponent("Tip");
  const _component_el_button = _resolveComponent("el-button");
  const _component_SingerV2 = _resolveComponent("SingerV2");
  const _component_el_step = _resolveComponent("el-step");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _component_el_steps = _resolveComponent("el-steps");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " " + _toDisplayString($props.nodeId), 1)]), _hoisted_4, !$data.canOffboarding ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [!$data.haveGuaranteeNodeId ? (_openBlock(), _createBlock(_component_Tip, {
    key: 0,
    level: "error"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('Offboarding.There are outstanding debts')), 1)]),
    _: 1
  })) : _createCommentVNode("", true), $data.haveGuaranteeNodeId ? (_openBlock(), _createBlock(_component_Tip, {
    key: 1,
    level: "error"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('Offboarding.There are haveGuaranteeNodeId debts')), 1)]),
    _: 1
  })) : _createCommentVNode("", true), $data.haveGuaranteeNodeId ? (_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    onClick: $options.unBindNode,
    class: "mt-3 btn btn-primary w-100 i-button",
    type: "submit"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.TerminateGuarantee')), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.isFineOffBoard ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_Tip, null, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('Offboarding.isFineOffBoardTip').toString().replaceAll('$$$nodeId$$$', $props.nodeId)), 1)]),
    _: 1
  })])])) : _createCommentVNode("", true), $data.canOffboarding && !$data.isFineOffBoard ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_steps, {
    direction: "vertical",
    active: $data.active
  }, {
    default: _withCtx(() => [_createVNode(_component_el_step, {
      icon: $data.CircleCheckFilled
    }, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: _normalizeClass(["col-12 text-left fw-extra-bold", _ctx.isMobileWidth ? 'fsi-16' : 'fsi-20']),
        style: _normalizeStyle({
          width: _ctx.fixedMaxWidth
        })
      }, _toDisplayString(_ctx.$t('Offboarding.Submit a')) + " \"Change" + _toDisplayString($options.nodeRole === 'Beneficiary' ? $options.nodeRole : $options.nodeRole + 'Address') + "\" " + _toDisplayString(_ctx.$t('Offboarding.proposal by lengin pool')), 7)])]),
      description: _withCtx(() => [_createElementVNode("div", _hoisted_13, [!$data.sendProposal ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_Tip, {
        level: "tips"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [$options.nodeRole === 'Owner' ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('Onboarding.The original owner will take over the ownership')), 1)) : _createCommentVNode("", true), $options.nodeRole !== 'Owner' ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('Offboarding.The original owner will take over the authority of the node beneficiary')), 1)) : _createCommentVNode("", true), _hoisted_17, _hoisted_18, _createTextVNode(" " + _toDisplayString(_ctx.$t('Offboarding.Once the first step is complete')), 1)])]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [!$data.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('Offboarding.Address')), 1), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
        style: _normalizeStyle([{
          "max-width": "480px"
        }, {
          width: _ctx.fixedMaxWidth
        }]),
        class: "link-text-ordinary",
        onClick: _cache[0] || (_cache[0] = $event => $options.gotoAddress($data.originalOwner, _ctx.$i18n.locale))
      }, _toDisplayString($data.originalOwner), 5)])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", {
        class: "col-lg-9 col-12 text-lg-right text-left fw-medium fsi-14 link-text-ordinary",
        onClick: _cache[1] || (_cache[1] = $event => $options.gotoAddress($data.originalOwnerF0, _ctx.$i18n.locale))
      }, _toDisplayString($data.originalOwnerF0), 1)])], 64)) : _createCommentVNode("", true), $data.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
        style: {
          "max-width": "480px"
        },
        class: "link-text-ordinary",
        onClick: _cache[2] || (_cache[2] = $event => $options.gotoAddress($data.originalOwnerF0, _ctx.$i18n.locale))
      }, _toDisplayString($data.originalOwnerF0), 1)])])) : _createCommentVNode("", true)])]), $data.isActive ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [$data.oneStepSignType === 'evm' ? (_openBlock(), _createBlock(_component_SingerV2, {
        key: 0,
        ref: "singer-evm",
        nodeRole: $options.nodeRole,
        "to-eth-address": $data.oneStepToEthAddress,
        "to-f0-address": $data.oneStepToF0Address,
        "wait-time": 31000,
        "is-call-evm": true,
        contractABI: $data.contractABI,
        isBeneficiaryUndelegate: true,
        btnProposal: "Send Proposal",
        "contract-method": $data.contractMethod,
        contractParams: $data.contractParams,
        onLoading: $options.initSignLoading,
        onNext: $options.showNextStepBtnFun
      }, null, 8, ["nodeRole", "to-eth-address", "to-f0-address", "contractABI", "contract-method", "contractParams", "onLoading", "onNext"])) : _createCommentVNode("", true), $data.oneStepSignType === 'offline' ? (_openBlock(), _createBlock(_component_SingerV2, {
        key: 1,
        ref: "singer-offline",
        nodeRole: $options.nodeRole,
        "from-address": $data.originalOwner,
        "to-f0-address": $data.oneStepToF0Address,
        "wait-time": 31000,
        "is-call-evm": false,
        contractABI: $data.contractABI,
        isBeneficiaryUndelegate: true,
        btnProposal: "Send Proposal",
        "contract-method": $data.contractMethod,
        contractParams: $data.contractParams,
        onLoading: $options.initSignLoading,
        onNext: $options.showNextStepBtnFun
      }, null, 8, ["nodeRole", "from-address", "to-f0-address", "contractABI", "contract-method", "contractParams", "onLoading", "onNext"])) : _createCommentVNode("", true), $data.oneStepSignType === 'evm' && !$data.showNextStepBtn && !$data.signLoading ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "text-center fsi-14 link-text",
        onClick: _cache[3] || (_cache[3] = $event => $options.checkOwnerSign('offline'))
      }, _toDisplayString(_ctx.$t('common.Sign the node source Owner offline')), 1)) : _createCommentVNode("", true), $data.oneStepSignType === 'offline' && !$data.showNextStepBtn && !$data.signLoading ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "text-center fsi-14 link-text",
        onClick: _cache[4] || (_cache[4] = $event => $options.checkOwnerSign('evm'))
      }, _toDisplayString(_ctx.$t('common.Loan pool administrator signature')), 1)) : _createCommentVNode("", true), $data.showNextStepBtn ? (_openBlock(), _createBlock(_component_el_button, {
        key: 4,
        onClick: $options.sendProposalFun,
        class: "btn btn-primary w-100 i-button",
        type: "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Next')), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["icon"]), _createVNode(_component_el_step, null, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Onboarding.Approval proposal by original owner')), 1)])]),
      description: _withCtx(() => [$data.active === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [!$data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_Tip, {
        level: "tips"
      }, {
        default: _withCtx(() => [_createElementVNode("b", null, _toDisplayString(_ctx.$t('Offboarding.not skip this step')), 1), _createTextVNode(_toDisplayString(_ctx.$t('Offboarding.not skip this step2')), 1)]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createVNode(_component_SingerV2, {
        ref: "singer2",
        "from-address": $data.towStepFromAddress,
        "to-f0-address": $data.towStepToF0Address,
        "is-call-evm": false,
        "wait-time": 30000,
        contractABI: $data.contractABI,
        nodeRole: $options.nodeRole,
        btnProposal: "Send Proposal",
        isBeneficiaryUndelegate: true,
        changeAddress: $data.changeAddress,
        onNext: $options.approvedProposal2
      }, null, 8, ["from-address", "to-f0-address", "contractABI", "nodeRole", "changeAddress", "onNext"])])]), $data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_AdCard2, {
        title: _ctx.$t('Onboarding.You have successfully offboarded'),
        content: _ctx.$t('Onboarding.Thank you for your unwavering')
      }, null, 8, ["title", "content"])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["active"])])])])) : _createCommentVNode("", true)]);
}